import type {
  CountryCode,
  Source,
  SpatialAggregationType
} from "@/types/common";
import type { License } from "@/types/dataset";

/** sessionStorage key holding the Dataset Explorer modal's UI state. */
export const SESSION_STORAGE_KEY = "dataset-explorer-modal";

export interface DatasetExplorerSessionStorageData {
  searchQuery: string;
  searchDataSource: string;
  country: CountryCode;
  dataSource: Source;
  spatialAggregationType: SpatialAggregationType | "all";
  published: boolean;
  currentPage: number;
  pageSize: number;
  license: License | "all";
  providerId: string;
}

export const DEFAULT_SESSION_DATA: DatasetExplorerSessionStorageData = {
  searchQuery: "",
  searchDataSource: "",
  country: "",
  dataSource: "bvt",
  spatialAggregationType: "all",
  published: true,
  currentPage: 1,
  pageSize: 10,
  license: "all",
  providerId: ""
};
